// extracted by mini-css-extract-plugin
export default {"tabNavigationBar":"Navigation_tabNavigationBar__twJzw"};